import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[formGroupDef]' })
export class FormGroupDef {
  constructor(public template: TemplateRef<any>) { }
}

@Directive({ selector: '[defaultFormGroupDef]' })
export class DefaultFormGroupDef {
  constructor(public template: TemplateRef<any>) { }
}

@Directive({ selector: '[formTemplateDef]' })
export class FormTemplateDef {
  constructor(public template: TemplateRef<any>) { }
}

@Directive({ selector: '[defaultFormTemplateDef]' })
export class DefaultFormTemplateDef {
  constructor(public template: TemplateRef<any>) { }
}

@Directive({ selector: '[formDividerDef]' })
export class FormDividerDef {
  constructor(public template: TemplateRef<any>) { }
}

@Directive({ selector: '[defaultFormDividerDef]' })
export class DefaultFormDividerDef {
  constructor(public template: TemplateRef<any>) { }
}
